import { render, staticRenderFns } from "./ProjectLogo.vue?vue&type=template&id=c18f84dc&scoped=true"
import script from "./ProjectLogo.vue?vue&type=script&lang=js"
export * from "./ProjectLogo.vue?vue&type=script&lang=js"
import style0 from "./ProjectLogo.vue?vue&type=style&index=0&id=c18f84dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18f84dc",
  null
  
)

export default component.exports